import React from 'react';
import { Link } from 'react-router-dom';
import PasswordCHangeModal from '../../register/PasswordChangeModal';


export default function Header(param) {

    function logOut() {
        sessionStorage.removeItem("loginToken");
    }
    
    function barClick() {
        console.log("click");
        param.callbackSideBarCheck();
    }

    return(
        <div>
            <nav className="main-header navbar navbar-expand navbar-white navbar-light">
                {/* header상단의 sidebar열고 접는 버튼 
                     <ul className="navbar-nav">
                        <li className="nav-item">
                            <Link className="nav-link" data-widget="pushmenu" to="#" onClick={barClick}><i className="fas fa-bars"></i> </Link>
                        </li>
                    </ul> 
                */}
                <ul className="navbar-nav ml-auto">
                    {/* <li className="nav-item">
                    <Link className="nav-link" to="#"><i className="fa fa-sign-out-alt" ></i></Link>
                    </li> */}

                    <li className="nav-item dropdown">
                        <a className="nav-link" data-toggle="dropdown" href="#">
                        {/* <i className="far fa-comments"></i> */}
                        {/* <span className="badge badge-danger navbar-badge">3</span> */}
                        개인정보
                        </a>
                        <div className="dropdown-menu dropdown-menu-header">
                        <a data-toggle="modal" data-target="#passwordChangeModal" className="dropdown-item" >
                            패스워드 수정
                        </a>
                        <div className="dropdown-divider"></div>
                        <a href="/signin" className="dropdown-item" onClick={logOut}>
                            로그아웃
                        </a>
                        </div>
                    </li>
                </ul>
            </nav>
            
            <PasswordCHangeModal check={true}></PasswordCHangeModal>
        </div>
    );
}